import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";

const GNBPURE00000S = () => {
 const { doAction } = useApplicationCommon(); // ✅ `doAction`만 사용
 const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태
  


  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type01">
          <h2>기업소개</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>CEO인사말<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE00000S">CEO인사말</Link></li>
                <li><Link to="/GNBPURE00001S">ABOUT US</Link></li>
                <li><Link to="/GNBPURE03001S">우리회사소식</Link></li>
                <li><Link to="/GNBPURE00002S">사업실적</Link></li>
                <li><Link to="/GNBPURE00003S">오시는길</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            <h3>CEO인사말</h3>
            <div className="ceo_inner">
              <img src="../../asset/img/subA/ceo_img.png" alt="ceo이미지" />

              <dl>
                <dt>
                  기술 그 이상의 감동과 웃음을 <br />
                  고객에게 선사할 수 있는 <br />
                  참된 기업이 되겠습니다.
                </dt>
                <dd>
                  디지털화, 융합화, 유비쿼터스로 집약되는 21세기 정보통신기술 환경에서 최고의 기술력을 가진 전문가들이 뜻을 모아 하나의 동아리를 만들었습니다. <br />
                  <br />
                  GnB & Pure 최초 설립 시부터 원천기술을 기반으로 하여, 중소형 금융기관 전문 SI업체로 출발하였으며 앞으로도 중소형 금융기관이 하루가 다르게 변화해가는 기업환경에서 새로운 비즈니스를 창출해내고, 기업가치를 증식해 나갈 수 있도록 중소형 금융기관을 위한 국내 초 일류 기술 Provider로서의역활을 충실히 이행해 나가고자 합니다. 이를 위해 GnB & Pure 는 기술력의 전문화에 더욱 주력하겠습니다. <br />
                  <br />
                  단순히 최신의 IT기술 흐름을 따라가고자 하는 것이 아닌, 중소형 금융기관 시장환경에 대한 철저한 분석과 중소형 금융기관 전산시스템, 특히 업무시스템에 대한 해박한 지식에 선진 IT 기술을 접목하여 통합차세대뱅킹시스템을 비롯, 주식매입자금대출시스템, 정보계시스템 등 중소형 금융기관 업무시스템을 기반으로 한 우수한 통합솔루션 제품들을 향후로도 더 많이 개발하기 위해 노력하겠습니다. <br />
                  이는 성공을 위해 노력하는 것이 아니라 노력하는 행동 그자체가 고객의 믿음을 지켜가는 유일한 길이기 때문이며, 이에 GnB & Pure 는 단순히 기술 제공자가 아닌, 그 이상의 감동과 웃음을 고객에게 선사할 수 있는 참된 기업이 되겠습니다. <br />
                  <br />
                  감사합니다. <br />
                  <br />
                  <span>
                    GnB 소프텍 & 퓨어솔루션 대표이사 <br />
                    차 호 열 올림
                  </span>
                </dd>
              </dl>
            </div>

          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE00000S;